@if (location()) {
    <div class="container">
        <ul class="location-details-list">
            <li>
                <div class="label inModal">Address Line 1</div>
                <div class="value">{{ location().line1 }}</div>
            </li>
            <li>
                <div class="label inModal">Address Line 2</div>
                <input
                    class="value"
                    [placeholder]="isReadOnly() && !line2() ? '' : 'Add Address Line 2'"
                    type="text"
                    [ngModel]="line2()"
                    (ngModelChange)="line2.set($event)"
                    [readOnly]="isReadOnly()"
                />
            </li>
            <li>
                <div class="label inModal">Country</div>
                <div class="value">{{ location().countryName }}</div>
            </li>
            <li>
                <div class="label inModal">State</div>
                <div class="value">{{ location().stateName }}</div>
            </li>
            <li>
                <div class="label inModal">City</div>
                <div class="value">{{ location().cityName }}</div>
            </li>
            @if (location().zipCode) {
                <li>
                    <div class="label inModal">Zip Code</div>
                    <div class="value">{{ location().zipCode }}</div>
                </li>
            }
        </ul>
    </div>
}
